import { render } from "./MyVouchers.vue?vue&type=template&id=c50541b2&scoped=true"
import script from "./MyVouchers.vue?vue&type=script&lang=js"
export * from "./MyVouchers.vue?vue&type=script&lang=js"

import "./MyVouchers.vue?vue&type=style&index=0&id=c50541b2&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c50541b2"]])

export default __exports__